import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import FloatingVue from "floating-vue";

createApp(App).use(store).use(router).use(FloatingVue).mount("#app");
